import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import InternetChecker from "./Components/InternetChecker";

import App from "./App";

// Get the root element from the DOM
const rootElement = document.getElementById("root");

// Create the root using createRoot from react-dom/client
const root = createRoot(rootElement);
window.baseUrl = window.location.origin + "/";

// Render the App component
root.render(
  <I18nextProvider i18n={i18n}>
    <InternetChecker />
    <App />
  </I18nextProvider>
);
